var React = require('react');

function Envelope (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_3460","data-name":"Path 3460","d":"M240.152,241.785a.834.834,0,0,1-1.083,0l-9.375-8.528h19.833Zm-11.041-7.951v12.788a1.645,1.645,0,0,0,1.654,1.636h17.693a1.645,1.645,0,0,0,1.653-1.636V233.834L240.2,243.64a.832.832,0,0,1-1.169,0Z","transform":"translate(-229.111 -233.257)","fill":"#f7f7f7"}));
}

Envelope.defaultProps = {"id":"Rejestracja_-_email","data-name":"Rejestracja - email","width":"21","height":"15","viewBox":"0 0 21 15"};

module.exports = Envelope;

Envelope.default = Envelope;
